$ ->

  open_bulk_edit_action = (action, ids) ->
    if action and _.isArray(ids) and ids.length
      $.ajax
        url: "#{action}"
        method: 'POST'
        data:
          ids: "#{ids.join(',')}"

        dataType: 'json'
        beforeSend: () ->
          Loader.show()
        error: () ->
          Loader.hide()
        success: (data) ->
          if data? and data.redirectUrl
            window.location = data.redirectUrl

  $(document).on 'change', 'input[name="bulk_edit"]', (e) ->
    self = $ e.currentTarget
    checked_type = self.closest('[data-bulk-edit-unique-type]').attr('data-bulk-edit-unique-type')
    checked_count = $('input[name="bulk_edit"]:checked').length
    $('[data-bulk-edit-selected-count]').text checked_count
    $('[data-bulk-edit-menu]').toggleClass 'hidden', !checked_count
    
    if !checked_count
      $("[data-bulk-edit-unique-type]").removeClass('invisible')
    else
      $("[data-bulk-edit-unique-type]").addClass('invisible')
      $("[data-bulk-edit-unique-type='#{checked_type}']").removeClass('invisible')

  $(document).on 'click', '[data-bulk-edit-action]', (e) ->
    e.preventDefault()
    self = $ @
    action = self.attr('data-bulk-edit-action')
    ids = []

    unique_type_last = null
    unique_type_error = false
    $('input[name="bulk_edit"]:checked').each () ->
      input = $ @

      id = +input.val()
      ids.push(id) if id

      unique_type = input.closest('[data-bulk-edit-unique-type]').attr('data-bulk-edit-unique-type')
      unique_type_last ?= unique_type
      if unique_type_last != unique_type
        unique_type_error = true

    if unique_type_error
      INTENT.utils.Notify.warning __('campaigns.bulk-edit.unique-type-error')
    else if ids.length
      open_bulk_edit_action action, ids

  $('[data-bulk-edit-select-cancel]').on 'click', (e) ->
    e.preventDefault()
    $('input[name="bulk_edit"]:checked').checkbox('click')

  $('[data-bulk-edit-select-all]').on 'click', (e) ->
    e.preventDefault()
    $("[data-bulk-edit-unique-type]")
      .not('.invisible')
      .find('input[name="bulk_edit"]')
      .prop('checked', 'checked')
      .trigger('change')